/**
 * R4 — Utilitários puros para as páginas legais.
 *
 * Mantido isolado de LegalPage.jsx (que importa react-markdown / remark-gfm,
 * ESM-only) para que os testes Jest do CRA possam exercitar a lógica sem
 * arrastar essas deps.
 */

/**
 * Remove o bloco de rascunho do topo (citações `>` antes do primeiro `#`)
 * e o parágrafo final em itálico (`*Documento de rascunho…*`), mantendo
 * apenas o corpo legal "público" dos markdowns em `src/content/legal/`.
 */
export function stripDraftBlocks(md) {
  if (typeof md !== "string") return "";
  // Corta tudo antes do primeiro título de nível 1 — derruba o bloco
  // `> RASCUNHO — REVISÃO JURÍDICA…`.
  const firstHeading = md.search(/^#\s/m);
  let body = firstHeading >= 0 ? md.slice(firstHeading) : md;
  // Corta o rodapé interno: a partir do último separador `---` se ele for
  // seguido apenas por parágrafo em itálico (`*Documento de rascunho…*`).
  body = body.replace(/\n---\s*\n+\*[^*]+\*\s*$/m, "\n");
  return body.trim();
}
